// Info/legal pages served as static HTML from /public (work on preview + nikah-match.com).
export const FOOTER_LINKS = [
  ["App Description", "/about.html"],
  ["Privacy Policy", "/privacy-policy.html"],
  ["Support", "/support.html"],
  ["Terms of Service", "/terms-of-service.html"],
  ["Community Guidelines", "/community-guidelines.html"],
  ["Child Safety", "/child-safety.html"],
  ["User Responsibilities", "/users-responsibilities.html"],
  ["Account Deletion", "/account-deletion.html"],
  ["Contact", "/contact.html"],
  ["Premium", "/premium-subscriptions.html"],
  ["Download App", "/download.html"],
];

export function FooterLinks({ className = "", linkClassName = "hover:text-emerald-800" }) {
  return (
    <div className={className} data-testid="footer-links">
      {FOOTER_LINKS.map(([label, href]) => (
        <a
          key={href}
          href={href}
          className={linkClassName}
          data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
        >
          {label}
        </a>
      ))}
    </div>
  );
}
